import { FC } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

type IBasicToggleButtonGroup = {
	activeButton: number;
	handleToggle?: (_: React.SyntheticEvent, newValue: number) => void;
	activeButtonClasses?: string;
	nonActiveButtonClasses?: string;
	titles: (string | Element)[];
	className?: string;
};

const BasicToggleButtonGroup: FC<IBasicToggleButtonGroup> = ({ activeButton, handleToggle, activeButtonClasses, nonActiveButtonClasses, titles, className }) => {
	return (
		<ToggleButtonGroup value={activeButton} exclusive onChange={handleToggle} className={`rounded-lg border border-grey-400 p-1 ${className}`}>
			{titles.map((title, index) => (
				<ToggleButton key={index} value={index} className={`${activeButton === index && activeButtonClasses} border-none text-sm ${nonActiveButtonClasses}`}>
					{title as string}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	);
};

export default BasicToggleButtonGroup;
